<template>
    <div v-if="isAccountLoaded">
        profile:<br>
        firstname: {{profile.firstName}}
        <input v-model="editProfile.firstName">
        <br>
        <button @click="clickSave()">save first name</button>
    </div>
</template>
<script>
import AccountMixin from "@/mixin/AccountMixin.js";

export default {
    name: "TestProfile",
    mixins: [AccountMixin],
    data: function() {
        return {
            editProfile: null,
        };
    },
    methods: {
        // mixin function
        accountInitiated: function() {
            if (this.isLogin) {
                console.log(this.profile);
                this.editProfile = {...this.profile};

            } else {
                console.log('not login');
            }
        },
        // mixin function

        clickSave: function() {
            this.setProfile(this.editProfile);
            console.log(this.profile);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
